export const validationRules = {
    required: value => !!value || 'Поле обязательно для заполнения',
    required_action_type: value => !!value || 'Действие не должно быть пустым, проведите Обследование',
    email: value => {
        if (value === '' || value === null || !value) {
            return true;
        }
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Формат введенного E-mail неверный. Пример: "a@a.a"';
    },
    phone: value => {
        if (value === '' || value === null || !value) {
            return true;
        }
        const phonePattern = /^\+7 \(\d{3}\) \d{3} \d{2} \d{2}$/;
        return phonePattern.test(value) || 'Неверный формат номера телефона';
    },
    required_bool: value => {
        if (value == true || value == false) {
            return true;
        }
        return 'Поле обязательно для заполнения';
    }
};
